import '@hapana/shared/utils/type-defs.util'

/** @type{Styles} */
export const styles = {
  tanningFeatureImageContainer: {
    display: 'flex',
  },
  tanningFeaturesContainer: {
    py: 1.5,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  tanningFeatureImage: {
    width: 20,
    height: 20,
    objectFit: 'cover',
    borderRadius: 10,
  },
  availableEquipmentsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
  loadingContainer: {
    p: 1,
  },
  textContainer: {
    marginLeft: 1.5,
    marginRight: 1,
    textAlign: 'center',
  },
  imagesTextContainer: {
    display: 'flex',
    alignItems: 'center',
  },
}
